module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 white",
    attrs: {
      "fill-height": ""
    }
  }, [(_vm.filtrationSystem.filtrationSystemId) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "grey lighten-4",
    attrs: {
      "xs12": "",
      "sm3": "",
      "id": "sidebar"
    }
  }, [_c('v-container', [(_vm.userRole === _vm.viewerRoleName) ? _c('span', {
    staticClass: "caption hidden-xs-only orange--text"
  }, [_vm._v(_vm._s(_vm.$t('account.function-limit')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_vm._v("  " + _vm._s(_vm.location.locationName))]), _vm._v(" "), _c('div', {
    staticClass: "device-setting-btn"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "slot": "activator",
      "icon": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.openDeviceEditDialog(_vm.filtrationSystem.filtrationSystemId)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('device-edit-dialog', {
    ref: "deviceEditDialog",
    on: {
      "child-action": _vm.getFiltrationSystem
    }
  }), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "slot": "activator",
      "icon": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showWaterSystemDeleteDialog(_vm.filtrationSystem)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('water-system-delete-dialog', {
    ref: "waterSystemDeleteDialog",
    on: {
      "delete-succeed": _vm.reloadWaterSystemList
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "id": "device-name"
    }
  }, [_vm._v(_vm._s(_vm.filtrationSystem.filtrationSystemName))]), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-2 pa-1 caption"
  }, [_vm._v("UID:" + _vm._s(_vm.filtrationSystem.jm1UniqueId))]), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-2 pa-1 caption"
  }, [_vm._v(_vm._s(_vm.$t('watersystem.last-update')) + ":" + _vm._s(_vm.unixToDatetime(_vm.filtrationSystem.modifiedTime)))]), _vm._v(" "), _vm._l((_vm.filtrationSystem.dispServices), function(service) {
    return _c('div', [(service.serviceId == 1) ? _c('div', {
      staticClass: "mt-3",
      class: _vm.flowAndTimeMeta.timeColor === 'blue' ? '' : _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_c('v-icon', {
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('watersystem.elapsed-time')) + "\n            "), _c('div', {
      staticClass: "ml-4"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.flowAndTimeMeta.fromNowMonth) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("\n                /" + _vm._s(_vm.flowAndTimeMeta.maxLifeMonth) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n              ")])]), _vm._v(" "), _c('hr', {
      staticClass: "mt-1"
    })], 1) : _vm._e(), _vm._v(" "), (service.serviceId == 1) ? _c('div', {
      staticClass: "mt-3",
      class: _vm.flowAndTimeMeta.flowColor === 'blue' ? '' : _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_c('v-icon', {
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('watersystem.total-flow')) + "\n            "), _c('div', {
      staticClass: "ml-4"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.flowAndTimeMeta.leftFlowFormated) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("\n                /" + _vm._s(_vm.flowAndTimeMeta.maxFlowFormated) + " " + _vm._s(_vm.unit) + "\n              ")])]), _vm._v(" "), _c('hr', {
      staticClass: "mt-1"
    })], 1) : _vm._e(), _vm._v(" "), (service.serviceId == 2) ? _c('div', {
      staticClass: "mt-3",
      class: _vm.getClassNameServiceStatus(service).replace('blue--text', '')
    }, [_c('v-icon', {
      class: _vm.getClassNameServiceStatus(service)
    }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('watersystem.RoMembrane-short')) + "\n            "), _c('div', {
      staticClass: "ml-4"
    }, [(_vm.getServiceStatus(service) == 2) ? _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-alert')))]) : (_vm.getServiceStatus(service) == 1) ? _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-caution')))]) : _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t('watersystem.RoMembrane-good')))])]), _vm._v(" "), _c('hr', {
      staticClass: "mt-1"
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((service.details), function(detail) {
      return (service.serviceId == 3) ? _c('div', {
        staticClass: "mt-3",
        class: _vm.getClassNamePluginStatus(detail).replace('blue--text', '')
      }, [_c('v-icon', {
        class: _vm.getClassNamePluginStatus(detail)
      }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            A" + _vm._s(detail.portNumber) + " " + _vm._s(_vm.$t('watersystem.temperature-short')) + "\n            "), _c('div', {
        staticClass: "ml-4"
      }, [(_vm.getPluginStatus(detail) == 2) ? _c('span', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(_vm.convertTemperatureUnit(detail.currentRate)) + _vm._s(' ' + _vm.temperatureUnit) + "\n              ")]) : (_vm.getPluginStatus(detail) == 1) ? _c('span', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(_vm.convertTemperatureUnit(detail.currentRate)) + _vm._s(' ' + _vm.temperatureUnit) + "\n              ")]) : _c('span', {
        staticClass: "title"
      }, [_vm._v("\n                " + _vm._s(_vm.convertTemperatureUnit(detail.currentRate)) + _vm._s(' ' + _vm.temperatureUnit) + "\n              ")])]), _vm._v(" "), _c('hr', {
        staticClass: "mt-1"
      })], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((service.details), function(detail) {
      return (service.serviceId == 4) ? _c('div', {
        staticClass: "mt-3",
        class: _vm.getClassNamePluginStatus(detail).replace('blue--text', '')
      }, [_c('v-icon', {
        class: _vm.getClassNamePluginStatus(detail)
      }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            A" + _vm._s(detail.portNumber) + " " + _vm._s(_vm.$t('watersystem.leakage-short')) + "\n            "), _c('div', {
        staticClass: "ml-4"
      }, [(_vm.getPluginStatus(detail) == 2) ? _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.$t('watersystem.leakage-alert')))]) : _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.$t('watersystem.leakage-normal')))])]), _vm._v(" "), _c('hr', {
        staticClass: "mt-1"
      })], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((service.details), function(detail) {
      return (service.serviceId == 5) ? _c('div', {
        staticClass: "mt-3",
        class: _vm.getClassNamePluginStatus(detail).replace('blue--text', '')
      }, [_c('v-icon', {
        class: _vm.getClassNamePluginStatus(detail)
      }, [_vm._v("\n              fiber_manual_record\n            ")]), _vm._v("\n            A" + _vm._s(detail.portNumber) + " " + _vm._s(_vm.$t('watersystem.Pressure-short')) + "\n            "), _c('div', {
        staticClass: "ml-4"
      }, [(_vm.getPluginStatus(detail) == 2) ? _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.convertPressureUnit(detail.currentRate)) + _vm._s(' ' + _vm.pressureUnit))]) : (_vm.getPluginStatus(detail) == 1) ? _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.convertPressureUnit(detail.currentRate)) + _vm._s(' ' + _vm.pressureUnit))]) : _c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.convertPressureUnit(detail.currentRate)) + _vm._s(' ' + _vm.pressureUnit))])]), _vm._v(" "), _c('hr', {
        staticClass: "mt-1"
      })], 1) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3",
    attrs: {
      "id": "location"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('watersystem.customer-info')))]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1",
    attrs: {
      "id": "address"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.location.locationAddress))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1",
    attrs: {
      "id": "phone"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.location.locationPhone))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1",
    attrs: {
      "id": "contact"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.location.organizationContact))])])])], 2), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('csv-download-dialog', {
    attrs: {
      "earliestLogInfo": _vm.earliestLogInfo,
      "locale": _vm.locale,
      "timezone": _vm.selectedTimezone,
      "filtrationSystemProp": _vm.filtrationSystem,
      "filterProp": _vm.filter
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "white",
      "height": "30px",
      "id": "watersystem-tab"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.filtrationSystem.dispServices), function(service) {
    return _c('v-tab', {
      key: _vm.serviceCodes[service.serviceId],
      attrs: {
        "href": '#' + _vm.serviceCodes[service.serviceId],
        "active-class": "white"
      }
    }, [_c('v-icon', {
      class: _vm.getClassNameServiceStatus(service)
    }, [_vm._v("\n             fiber_manual_record\n            ")]), _vm._v("\n            " + _vm._s(_vm.serviceNames[service.serviceId]) + "\n          ")], 1)
  }), _vm._v(" "), _c('v-tab', {
    class: _vm.activeTab == 'HISTORY' ? 'white' : 'grey lighten-3',
    attrs: {
      "href": "#HISTORY",
      "active-class": "white"
    },
    on: {
      "click": _vm.getHistory
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("watersystem.history")) + "\n          ")]), _vm._v(" "), _vm._l((_vm.filtrationSystem.dispServices), function(service) {
    return [(service.serviceId === 1) ? _c('v-tab-item', {
      attrs: {
        "id": "FLOW",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', [_c('v-layout', {
      staticClass: "pl-3"
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('h6', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.$t("settings.notification-presets")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('customer.undefined')))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('h6', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.$t("watersystem.column-nexttime")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.nextReplacement(_vm.filter.nextReplacementTime)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.frowSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                      "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-layout', {
      staticClass: "pl-3 pr-3",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_c('v-icon', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_vm._v("\n                          fa-tint\n                        ")]), _vm._v("\n                        " + _vm._s(_vm.$t('watersystem.rest-flow')) + "\n                      ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('span', {
      staticClass: "title",
      class: _vm.flowAndTimeMeta.flowColor + '--text'
    }, [_vm._v("\n                          " + _vm._s(_vm.flowAndTimeMeta.flowLifePercent) + "%\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "grey--text caption"
    }, [_vm._v("\n                          " + _vm._s(_vm.flowAndTimeMeta.flowLifeLeft) + "\n                        ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "ma-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-progress-linear', {
      staticClass: "ma-0",
      attrs: {
        "value": _vm.flowAndTimeMeta.flowLifePercent,
        "height": "20",
        "color": _vm.flowAndTimeMeta.flowColor
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-layout', {
      staticClass: "pl-3 pr-3",
      attrs: {
        "row": "",
        "wrap": "",
        "align-baseline": ""
      }
    }, [_c('v-flex', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_c('v-icon', {
      staticClass: "caption",
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_vm._v("\n                          fa-hourglass-half\n                        ")]), _vm._v("\n                         " + _vm._s(_vm.$t('watersystem.elapsed-time')) + "\n                      ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right"
    }, [_c('span', {
      staticClass: "title",
      class: _vm.flowAndTimeMeta.timeColor + '--text'
    }, [_vm._v("\n                          " + _vm._s(_vm.flowAndTimeMeta.fromNowMonth) + "\n                          " + _vm._s(_vm.$t("watersystem.period-month")) + "\n                        ")]), _vm._v(" "), _c('span', {
      staticClass: "grey--text caption"
    }, [_vm._v("\n                          /" + _vm._s(_vm.flowAndTimeMeta.maxLifeMonth) + "\n                          " + _vm._s(_vm.$t("watersystem.period-month")) + "\n                        ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-progress-linear', {
      staticClass: "ma-0",
      attrs: {
        "value": _vm.flowAndTimeMeta.timePercent,
        "height": "20",
        "color": _vm.flowAndTimeMeta.timeColor
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('flow-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.filter.configId,
        "timezone": _vm.selectedTimezone,
        "unit": _vm.unit,
        "slot-num": _vm.filter.slotNumber,
        "currentTab": _vm.currentTab,
        "activeTab": _vm.activeTab,
        "label-flow": _vm.$t('chart.graph-label-fromlastchange'),
        "label-flow-diff": _vm.$t('chart.graph-label-diff'),
        "label-flow-sum": _vm.$t('chart.graph-label-sum'),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outline": "",
        "disabled": !_vm.showForm || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.showResetDialog = true
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t("watersystem.filter-reset")) + "\n                      ")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                              " + _vm._s(_vm.$t('watersystem.flow-life')) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertMaxLifeSpanFlow(service.filters[0].maxLifeSpanFlow) + ' ' + _vm.unit) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertMaxLifeSpanFlow(service.filters[0].warningLifeSpanFlow) + ' ' + _vm.unit) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                              " + _vm._s(_vm.$t('watersystem.time-life')) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertSecondToMonth(service.filters[0].maxLifeSpanTime)) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.convertSecondToMonth(service.filters[0].warningLifeSpanTime)) + " " + _vm._s(_vm.$t('watersystem.period-month')) + "\n                            ")])])])])])], 1)], 1), _vm._v(" "), (_vm.frowSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 2) ? _c('v-tab-item', {
      attrs: {
        "id": "RO",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.roSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: " body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                    "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1), _vm._v(" "), _c('ro-rate-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':1',
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', ''),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(_vm.$t("watersystem.impurities-removal-rate")) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(service.alertRate) + " %\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(service.warningRate) + " %\n                      ")])])])]), _vm._v(" "), (_vm.roSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 3) ? _c('v-tab-item', {
      attrs: {
        "id": "TEMPERA",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_vm._l((service.details), function(detail) {
      return _c('div', [(_vm.getPluginStatus(detail) == 2) ? _c('p', [_c('span', {
        staticClass: "red--text"
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.temperature") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 2)) + "\n                  ")]) : (_vm.getPluginStatus(detail) == 1) ? _c('p', [_c('span', {
        staticClass: "orange--text"
      }, [_vm._v("\n                    " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.temperature") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 1)) + "\n                  ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      class: _vm.getClassNameTabInfoHeadlineNoDisp(service)
    }, [_c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("watersystem.temperature-normal")) + "\n                  ")])]), _vm._v(" "), _c('v-flex', [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.selectTemperatureEditPort),
        callback: function($$v) {
          _vm.selectTemperatureEditPort = $$v
        },
        expression: "selectTemperatureEditPort"
      }
    }, _vm._l((service.details), function(detail) {
      return _c('v-btn', {
        key: 'TEMPERA' + detail.portNumber,
        staticClass: "port-select-btn",
        attrs: {
          "flat": "",
          "value": detail.portNumber
        }
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber) + "\n                    ")])
    })), _vm._v(" "), _c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.temperatureSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                    "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('temperature-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.selectTemperatureEditPort,
        "selectEditPort": _vm.selectTemperatureEditPort,
        "details": service.details,
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', ''),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _vm._l((service.details), function(detail) {
      return _c('tr', [(detail.portNumber == _vm.selectTemperatureEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.$t("service.temperature")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 1) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].alertRate.min) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-min")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].alertRate.max) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-max")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 1) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].warningRate.min) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-min")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectTemperatureEditPort && service.validationType === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertTemperatureUnit(detail.settingData.temperature[0].warningRate.max) + ' ' + _vm.temperatureUnit + ' ' + _vm.$t("watersystem.temperature-max")) + "\n                      ")]) : _vm._e()])
    })], 2)]), _vm._v(" "), (_vm.temperatureSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 4) ? _c('v-tab-item', {
      attrs: {
        "id": "LEAK",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_vm._l((service.details), function(detail) {
      return _c('div', [(_vm.getPluginStatus(detail) == 2) ? _c('p', [_c('span', {
        staticClass: "red--text"
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.leakage") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 2)) + "\n                  ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      class: _vm.getClassNameTabInfoHeadlineNoDisp(service)
    }, [_c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("watersystem.leakage-all-normal")) + "\n                  ")])]), _vm._v(" "), _c('v-flex', [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.selectLeakageEditPort),
        callback: function($$v) {
          _vm.selectLeakageEditPort = $$v
        },
        expression: "selectLeakageEditPort"
      }
    }, _vm._l((service.details), function(detail) {
      return _c('v-btn', {
        key: 'LEAK' + detail.portNumber,
        staticClass: "port-select-btn",
        attrs: {
          "flat": "",
          "value": detail.portNumber
        }
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber) + "\n                    ")])
    }))], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('leakage-log', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.selectLeakageEditPort,
        "selectEditPort": _vm.selectLeakageEditPort,
        "details": service.details,
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', '')
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    })], 2)], 1) : _vm._e(), _vm._v(" "), (service.serviceId === 5) ? _c('v-tab-item', {
      attrs: {
        "id": "PRESS",
        "reverse-transition": "false",
        "transition": "false"
      }
    }, [_c('v-container', {
      staticClass: "white"
    }, [_vm._l((service.details), function(detail) {
      return _c('div', [(_vm.getPluginStatus(detail) == 2) ? _c('p', [_c('span', {
        staticClass: "red--text"
      }, [_vm._v("\n                    " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.pressure") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 2)) + "\n                  ")]) : (_vm.getPluginStatus(detail) == 1) ? _c('p', [_c('span', {
        staticClass: "orange--text"
      }, [_vm._v("\n                    " + _vm._s('A' + detail.portNumber + ' ' + _vm.$t("sensor.pressure") + ' ') + "\n                    ")]), _vm._v("\n                    " + _vm._s(_vm.getHeadlineMsg(detail.serviceId, detail.validationType, 1)) + "\n                  ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      class: _vm.getClassNameTabInfoHeadlineNoDisp(service)
    }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.headline-press-normal")) + "\n                  ")])]), _vm._v(" "), _c('v-flex', [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.selectEditPort),
        callback: function($$v) {
          _vm.selectEditPort = $$v
        },
        expression: "selectEditPort"
      }
    }, _vm._l((service.details), function(detail) {
      return _c('v-btn', {
        key: 'PRESS' + detail.portNumber,
        staticClass: "port-select-btn",
        attrs: {
          "flat": "",
          "value": detail.portNumber
        }
      }, [_vm._v("\n                      " + _vm._s('A' + detail.portNumber) + "\n                    ")])
    })), _vm._v(" "), _c('v-btn', {
      staticClass: "lighten-2 pa-0",
      attrs: {
        "small": "",
        "outline": "",
        "disabled": _vm.pressSettingBtnDisabled || _vm.userRole === _vm.viewerRoleName
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("settings")]), _vm._v(" \n                    "), _c('span', [_vm._v(_vm._s(_vm.$t('settings.title')))])], 1)], 1), _vm._v(" "), _c('hr', {
      staticClass: "ma-3"
    }), _vm._v(" "), _c('water-pressure-log-chart', {
      attrs: {
        "data-id": _vm.filtrationSystem.filtrationSystemId + ':' + _vm.selectEditPort,
        "timezone": _vm.selectedTimezone,
        "activeTab": _vm.activeTab,
        "color": _vm.getClassNameServiceStatus(service).replace('--text', ''),
        "earliestLogInfo": _vm.earliestLogInfo
      },
      on: {
        "emit-earliest-timestamp": _vm.emitEarliestTimestamp,
        "child-action": _vm.getFiltrationSystem
      }
    }), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t("watersystem.notification-threshold")))]), _vm._v(" "), _c('table', {
      staticClass: "tab-info-table"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.alert")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("watersystem.warning")))])]), _vm._v(" "), _vm._l((service.details), function(detail) {
      return _c('tr', [(detail.portNumber == _vm.selectEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.$t("service.pressure")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertPressureUnit(detail.alertRate) + ' ' + _vm.pressureUnit) + "\n                      ")]) : _vm._e(), _vm._v(" "), (detail.portNumber == _vm.selectEditPort) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.convertPressureUnit(detail.warningRate) + ' ' + _vm.pressureUnit) + "\n                      ")]) : _vm._e()])
    })], 2)]), _vm._v(" "), (_vm.pressSettingBtnDisabled === false && _vm.userRole !== _vm.viewerRoleName) ? _c('div', {
      staticClass: "setting-link-text"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text1")) + "\n                  "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openSettingDialog(service.serviceId)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text2")) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.$t("watersystem.setting-link-text3")) + "\n                ")]) : _vm._e()], 2)], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "HISTORY",
      "reverse-transition": "false",
      "transition": "false"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-3"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("watersystem.history")))])]), _vm._v(" "), _vm._l((_vm.history), function(hist) {
    return _c('v-layout', {
      key: hist.index
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('p', [_c('i', {
      staticClass: "fa",
      class: _vm.historyIcon(hist.type)
    }), _vm._v("\n                      " + _vm._s(_vm.unixToDatetime(hist.eventTime)) + "\n                    ")])]), _vm._v(" "), _c('v-flex', [_c('p', [_vm._v(_vm._s(_vm.historyTitle(hist.type)))])])], 1)
  })], 2)], 1)], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showResetDialog),
      callback: function($$v) {
        _vm.showResetDialog = $$v
      },
      expression: "showResetDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n              " + _vm._s(_vm.$t('watersystem.filter-reset-title')) + "\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n              " + _vm._s(_vm.$t('watersystem.filter-reset-text')) + "\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.isRoot,
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetFilter($event)
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.showResetDialog = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.filterResetDoBtnName) + "\n              ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showResetDialog = false
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('watersystem.filter-reset-cancel')) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('service-setting-dialog', {
    ref: "childSettingDialog"
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.failMessage) ? _c('v-flex', [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.failMessage))])]) : _c('v-flex', {
    staticClass: "white text-xs-center pt-5",
    attrs: {
      "xs12": "",
      "id": "before-select",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1",
    attrs: {
      "size": "70px"
    }
  }, [_vm._v("find_in_page")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('watersystem.please-select')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-3fac2e4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaterSystem.vue
// module id = 1921
// module chunks = 0